import { createAction, createRequestTypes, createRequestActions } from './utils';
export const FETCH_CAN_EDIT_USER = 'FETCH_CAN_EDIT_USER';
export const FetchIsRestrictedImpersonateeActionTypes = createRequestTypes(FETCH_CAN_EDIT_USER);
export const FetchIsRestrictedImpersonatee = createRequestActions(FetchIsRestrictedImpersonateeActionTypes);
export const loadIsRestrictedImpersonatee = () => createAction(FETCH_CAN_EDIT_USER);